import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const WAIT_WORD_CLOUD = 'wait-word-cloud'
export const NUMBER_OF_MENTIONS = 'number-of-mentions'
export const FEWER = 'fewer'
export const MORE = 'more'
export const NOT_YET_BEEN_ANSWERED = 'not-yet-been-answered'

export default {
  [PORTUGUESE]: {
    [WAIT_WORD_CLOUD]: 'Aguarde o carregamento da nuvem de palavras antes de exportar',
    [NUMBER_OF_MENTIONS]: 'Número de menções',
    [FEWER]: 'menos',
    [MORE]: 'mais',
    [NOT_YET_BEEN_ANSWERED]: 'Esta pergunta ainda não foi respondida',
  },

  [ENGLISH]: {
    [WAIT_WORD_CLOUD]: 'Wait for the word cloud to load before exporting',
    [NUMBER_OF_MENTIONS]: 'Number of mentions',
    [FEWER]: 'fewer',
    [MORE]: 'more',
    [NOT_YET_BEEN_ANSWERED]: 'This question has not yet been answered',
  },

  [SPANISH]: {
    [WAIT_WORD_CLOUD]: 'Espere a que se cargue la nube de palabras antes de exportar',
    [NUMBER_OF_MENTIONS]: 'Número de menciones',
    [FEWER]: 'menos',
    [MORE]: 'más',
    [NOT_YET_BEEN_ANSWERED]: 'Esta pregunta aún no ha sido respondida',
  },
}
